import { useState } from "react";
type Set<T> = (e: React.ChangeEvent<T>) => void;
export function useTarget<T = HTMLElement>(): [T, Set<T>, () => void] {
  const [el, setEl] = useState<T>(null);
  return [el, (e) => setEl(e.target), () => setEl(null)];
}
